// extracted by mini-css-extract-plugin
export default {"loLink":"PrimeNotificationText_loLink__8bo9k"};